import {format, isWithinInterval} from 'date-fns';
import {PtrnCampoEditableDatetime, PtrnCampoValidarResult} from '../../patronTypes';
import {FORMATS} from '../../constants';
import {PtrnValidarCampoFn} from './ptrnProcesarTypes';
import {PtrnProcesarUtilsCfg} from './ptrnProcesarUtils';
import {ValidateState} from 'lib.common';

export const ptrnValidarDate: PtrnValidarCampoFn<Date | null, PtrnCampoEditableDatetime> = (
   currValue,
   campoConfig,
   estado
) => {
   const validateResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();
   if (currValue) {
      if (campoConfig.maxDate && campoConfig.minDate) {
         if (!isWithinInterval(currValue, {start: campoConfig.minDate, end: campoConfig.maxDate})) {
            validateResult.errores.push(
               PtrnProcesarUtilsCfg.ErrValidar(
                  `La fecha debe estar entre ${format(
                     campoConfig.minDate,
                     FORMATS.date
                  )} y ${format(campoConfig.maxDate, FORMATS.date)}`
               )
            );
            validateResult.gravedadMaxima = ValidateState.ERROR;
            return validateResult;
         }
      } else {
         if (campoConfig.maxDate && currValue > campoConfig.maxDate) {
            validateResult.errores.push(
               PtrnProcesarUtilsCfg.ErrValidar(
                  `La fecha no puede ser posterior a ${format(campoConfig.maxDate, FORMATS.date)}`
               )
            );
            validateResult.gravedadMaxima = ValidateState.ERROR;
            return validateResult;
         }

         if (campoConfig.minDate && currValue < campoConfig.minDate) {
            validateResult.errores.push(
               PtrnProcesarUtilsCfg.ErrValidar(
                  `La fecha no puede ser anterior a ${format(campoConfig.minDate, FORMATS.date)}`
               )
            );
            validateResult.gravedadMaxima = ValidateState.ERROR;
            return validateResult;
         }
      }

      if (campoConfig.disableWeekends && [0, 6].includes(currValue.getDay())) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar('No se permiten fechas en fin de semana')
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }

      if (campoConfig.disabledDays?.includes(currValue.getDay())) {
         validateResult.errores.push(PtrnProcesarUtilsCfg.ErrValidar('Día no permitido'));
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }

      if (campoConfig.excludeDates?.some((date) => date.getTime() === currValue.getTime())) {
         validateResult.errores.push(PtrnProcesarUtilsCfg.ErrValidar('Fecha no permitida'));
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   }

   return validateResult;
};
